import { lazy } from 'react'
import { getLinkObject } from '../../services/getLinkObject'

export const MEDIASTORAGE_LINKS = {
  SEARCH: getLinkObject(
    '/mediastorage/search',
    'Search',
    lazy(() => import('./components/searchPanel/SearchPanel')),
    {},
    'ReadFilePrivilege'
  ),
  UPLOAD: getLinkObject(
    '/mediastorage/upload',
    'Upload',
    lazy(() => import('./components/uploadPanel/UploadPanel')),
    {},
    'CreateOrUpdateFilePrivilege'
  ),
  SETTINGS: getLinkObject(
    '/mediastorage/settings',
    'Settings',
    lazy(() => import('./components/settingsPanel/SettingsPanel')),
    {},
    'RegisterTypePrivilege'
  )
}

export const BASE_MEDIA_TYPES = {
  PICTURE: 'PICTURE',
  SOUND: 'SOUND',
  UNKNOWN: 'UNKNOWN'
}

export const METADATA_VALUE_TYPES = {
  ARRAY: {
    name: 'ARRAY',
    value: []
  },
  VALUE: {
    name: 'VALUE',
    value: ''
  },
  OBJECT: {
    name: 'OBJECT',
    value: {}
  }
}

export const EDITABLE_FILE_DATA_FIELDS = {
  TYPE: 'type',
  METADATA: 'metadata',
  LIFETIME: 'lifetime'
}

export const LIFETIME_TYPES = {
  INFINITE: 'INFINITE',
  DEFAULT: 'DEFAULT',
  MANUAL: 'MANUAL'
}
